import React, { useState } from 'react'
import Button from 'components/atoms/Button'
import FormInput from 'components/atoms/FormInput'
import { Link, useNavigate } from 'react-router-dom'
import forgotPasskey from '../../../assets/svg/forgotPassKey.svg'
import arrowLeft from '../../../assets/svg/larrow-left-long.svg'
import PageTitle from 'components/atoms/PageTitle'
import { BASE_URL, postRequest } from 'services/http'
import Alert from 'components/atoms/Alert'

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false)

  const [email, setEmail] = useState('')
  const [emailErr, setEmailErr] = useState('')

  const navigate = useNavigate()
  const disabledBtn = email === "" || loading === true;

  const forgotPassword = async (userData: any) => {
    setLoading(true);
    const res = await postRequest(`${BASE_URL}auth/password`, { headers: { 'Content-Type': 'application/json' } }, { email: userData });

    if (res?.data.responseCode === '00') {
      setLoading(false);
      Alert('success', res?.data.message);
      navigate('/auth/check_mail', { state: { recoveryEmail: email } });
    } else {
      setLoading(false);
      Alert('error', res?.data.message);
    }

  }

  const handleSubmit = e => {
    e.preventDefault();

    forgotPassword(email);
  }

  return (
    <form onSubmit={handleSubmit}>
      <img src={forgotPasskey} alt='SeerbitLogo' className='w-[40px] h-[40px] mb-3' />
      <PageTitle
        pageTitle='Forgot Password?'
        pageTitleStyle='font-semibold !text-2xl tablet:!text-xl'
        subTitle='No worries, we’ll send you reset instructions.'
        subTitleStyle='!text-[16px] leading-7 !text-Black2'
      />
      <span>
        <FormInput
          type="email"
          name="email"
          placeholder="example@gmail.com"
          inputStyle="border border-transparent text-Black2"
          label="Email Address"
          labelStyle="font-normal text-sm leading-6 text-Black2"
          onChange={(e) => setEmail(e.target.value)}
          value={email}
          validationErr={emailErr}
        />
      </span>
      <span>
        <Button
          btnType="submit"
          btnText={
            loading ? (
              "Loading..."
            ) : (
              "Reset Password"
            )
          }
          btnStyle={`${disabledBtn ? "cursor-not-allowed" : ""
            } bg-black text-white px-6 py-3 mt-12 w-full`}
          disabled={disabledBtn}
        // onClick={() => navigate('/auth/check_mail')}
        />
      </span>

      <Link to="/auth/login" className="flex justify-start items-center gap-3 mt-1 font-semibold text-black text-sm leading-7 cursor-pointer hover:underline hover:transition-all">
        <img src={arrowLeft} alt='arrowLeft' className='w-4 h-4' />
        Back to Login
      </Link>
    </form>
  )
}

export default ForgotPassword